var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"webchat-route-root"},[_c('div',{staticClass:"webchat-route"},[_c('react-wrapper',{attrs:{"component":_vm.webChat,"onGoToSummary":_vm.goToSummary}})],1),_c('EventLogic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }